export default __webpack_public_path__ + "static/media/AroundUs.b32070d4.JPG";